
import { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { User, LogOut } from "lucide-react";
import NavBar from "./NavBar";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";

interface LayoutProps {
  title?: string;
  children?: ReactNode;
}

const Layout = ({ title, children }: LayoutProps) => {
  const { user, signOut, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    console.log("Logging out...");
    await signOut();
    // Force a small delay to ensure state updates before navigation
    setTimeout(() => {
      console.log("Signed out, navigating to login...");
      navigate('/');
    }, 100);
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="py-4 px-4 bg-white shadow-sm flex items-center justify-between">
        <h1 className="text-xl font-bold text-center text-wellness-primary">
          {title || "Wellness Dashboard"}
        </h1>
        <DropdownMenu>
          <DropdownMenuTrigger className="focus:outline-none">
            {user?.user_metadata?.avatar_url ? (
              <img 
                src={user.user_metadata.avatar_url} 
                alt="User avatar" 
                className="h-8 w-8 rounded-full object-cover"
              />
            ) : (
              <div className="h-8 w-8 rounded-full bg-wellness-primary text-white flex items-center justify-center">
                <User size={18} />
              </div>
            )}
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel className="font-normal">
              <div className="flex flex-col space-y-1">
                <p className="text-sm font-medium leading-none">{user?.user_metadata?.name || user?.email}</p>
                <p className="text-xs leading-none text-muted-foreground">{user?.email}</p>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout}>
              <LogOut className="mr-2 h-4 w-4" />
              <span>Log out</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </header>
      <main className="flex-grow p-4 pb-20 overflow-auto">
        {children || <Outlet />}
      </main>
      <NavBar />
    </div>
  );
};

export default Layout;
